// This is to track how many people use the 'Just added for you' functionality in cart 

document.addEventListener('click', function(e) {
  var btn = e.target.closest('.js-add-cross-sell');
  if (!btn) return;

  setTimeout(function() {
    if (typeof gtag === 'function') {
      gtag('event', 'just_added_for_you_click', {
        product_title: btn.getAttribute('data-product-title'),
        product_id: btn.getAttribute('data-product-id'),
        variant_id: btn.getAttribute('data-variant-id'),
        section: 'just_added_for_you'
      });
    }
  }, 500);
});
